const adminConfiguration = {
    templateUrl: '/modules/admin-configuration/admin-configuration.html',
    controller: 'AdminConfigurationController',
};

angular
    .module('admin-configuration.module', ['ui.router'])
    .component('adminConfiguration', adminConfiguration)
    .config(function ($stateProvider) {
        $stateProvider
            .state('admin-configuration', {
                url: '/admin-configuration',
                component: 'adminConfiguration',
                resolve: {
                    auth: function (userService, $state, eventService) {
                        return userService
                            .resolve(['ACCESS_DASHBOARD'])
                            .then(() => {
                            })
                            .catch(() => {
                                eventService.trigger('userservice:unauthorized');
                                $state.go('frontpage');
                            });
                    },
                },
            });
    });